"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CLINICAL_ORDER_REQUEST_EXAMPLES = exports.cancelClinicalOrderRequestSchema = exports.signClinicalOrderWithApprovalRequestSchema = exports.signClinicalOrderRequestSchema = exports.createClinicalOrderRequestSchema = exports.clinicalOrderTypeSchema = void 0;
/**
 * Request contracts for the 4 Clinical Order endpoints. Field shapes
 * mirror `ClinicalOrderWorkflowApplicationService`'s own method
 * signatures (frozen, Stage 6C.3) exactly — the 4 `*MasterId` fields
 * mirror `ClinicalOrder`'s own real referential-integrity design
 * (exactly one set, matching `orderType`, enforced by a real database
 * `CHECK` constraint since Stage 6C.1 — this schema does NOT duplicate
 * that constraint as a Zod refinement, since
 * `validateOrderTargetReference` already enforces it at the Domain
 * Service layer and this stage adds no business logic).
 */
const zod_1 = require("zod");
const clinical_common_request_1 = require("./clinical-common.request");
exports.clinicalOrderTypeSchema = zod_1.z.enum(['LAB', 'RADIOLOGY', 'MEDICATION', 'PROCEDURE', 'NURSING', 'REFERRAL']);
exports.createClinicalOrderRequestSchema = zod_1.z.object({
    patientId: zod_1.z.string().uuid(),
    encounterId: zod_1.z.string().uuid(),
    orderType: exports.clinicalOrderTypeSchema,
    testMasterId: zod_1.z.string().uuid().optional(),
    radiologyProcedureMasterId: zod_1.z.string().uuid().optional(),
    drugMasterId: zod_1.z.string().uuid().optional(),
    procedureMasterId: zod_1.z.string().uuid().optional(),
    priorityTier: zod_1.z.number().int().min(0).optional(),
    orderDetail: zod_1.z.record(zod_1.z.string(), zod_1.z.unknown()).optional(),
    orderingProviderId: zod_1.z.string().uuid(),
    ...clinical_common_request_1.clinicalWorkflowExtrasShape,
});
exports.signClinicalOrderRequestSchema = zod_1.z.object({
    orderId: zod_1.z.string().uuid(),
    signedBy: zod_1.z.string().uuid(),
    expectedLockVersion: zod_1.z.number().int().positive(),
    ...clinical_common_request_1.clinicalWorkflowExtrasShape,
});
exports.signClinicalOrderWithApprovalRequestSchema = zod_1.z.object({
    orderId: zod_1.z.string().uuid(),
    orderType: exports.clinicalOrderTypeSchema,
    signedBy: zod_1.z.string().uuid(),
    signerRoleIds: zod_1.z.array(zod_1.z.string().uuid()),
    expectedLockVersion: zod_1.z.number().int().positive(),
    ...clinical_common_request_1.clinicalWorkflowExtrasShape,
});
exports.cancelClinicalOrderRequestSchema = zod_1.z.object({
    orderId: zod_1.z.string().uuid(),
    reason: zod_1.z.string().optional(),
    ...clinical_common_request_1.clinicalWorkflowExtrasShape,
});
exports.CLINICAL_ORDER_REQUEST_EXAMPLES = {
    createClinicalOrder: {
        patientId: '11111111-1111-1111-1111-111111111111',
        encounterId: '55555555-5555-5555-5555-555555555555',
        orderType: 'LAB',
        testMasterId: 'bbbbbbbb-bbbb-bbbb-bbbb-bbbbbbbbbbbb',
        orderingProviderId: '77777777-7777-7777-7777-777777777777',
    },
    signClinicalOrder: {
        orderId: 'cccccccc-cccc-cccc-cccc-cccccccccccc',
        signedBy: '77777777-7777-7777-7777-777777777777',
        expectedLockVersion: 1,
    },
    signClinicalOrderWithApproval: {
        orderId: 'cccccccc-cccc-cccc-cccc-cccccccccccc',
        orderType: 'MEDICATION',
        signedBy: '77777777-7777-7777-7777-777777777777',
        signerRoleIds: ['aaaaaaaa-aaaa-aaaa-aaaa-aaaaaaaaaaaa'],
        expectedLockVersion: 1,
    },
    cancelClinicalOrder: {
        orderId: 'cccccccc-cccc-cccc-cccc-cccccccccccc',
        reason: 'Ordered in error',
    },
};
//# sourceMappingURL=clinical-order.request.js.map